import MerchCategoriesList from './MerchCategoriesList';

export default MerchCategoriesList;
